import axios from 'axios';
//import Auth from './Auth';

const protocol = process.env.PROTOCOL || 'http:';

const instance = axios.create({
  baseURL: `${protocol}${process.env.CLOUD_CFO_URL}`,
});

/**
 * Update every api request
 * 1. Add jwt token in request header
 */
// instance.interceptors.request.use(
//     config => {
//         const token  = Auth.get();

//         if(token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }

//         return config;
//     }
// );

/**
 * Update every api response
 * 1. Store error details to redux store
 * 2. End page loading state
 * 3. Check if response was cancelled
 */
instance.interceptors.response.use(
  (response) => {
    if (response) {
      return response;
    }
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      error.message = 'Server Timeout';
    }

    return Promise.reject(error);
  }
);

const formatUrl = (url) => {
  if (url.startsWith('/auth') || url.startsWith('/api')) {
    return url;
  }

  return `${protocol}${process.env.CLOUD_CFO_URL}${url}`;
};

const CancelToken = axios.CancelToken;

let requestTerminator = {
  GET: {},
  POST: {},
  PUT: {},
};

const terminator = (method, url) => {
  if (requestTerminator[method][url]) {
    requestTerminator[method][url](
      `${method}: Endpoint ${url} was cancelled due to multiple requests.`
    );
  }
};

const axiosPool = {
  get: async (url, params = {}, extras = {}) => {
    if (params.cancellable === true) {
      terminator('GET', url);
    }

    return await instance.get(formatUrl(url), {
      params,
      cancelToken: new CancelToken(function executor(c) {
        requestTerminator['GET'][url] = c;
      }),
      ...extras,
    });
  },
  post: async (url, data, extras = {}) => {
    return await instance.post(formatUrl(url), data, {
      ...extras,
    });
  },
  put: async (url, data, extras = {}) => {
    return await instance.put(formatUrl(url), data, {
      ...extras,
    });
  },
  delete: async (url, data, extras = {}) => {
    return await instance.delete(formatUrl(url), data, {
      ...extras,
    });
  },
};

export default axiosPool;
